import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CombinedOrderGridItemFragment = { __typename?: 'CombinedOrderDocument', orderEntityType: Types.OrderEntityType, orderEntityId: string, orderEntityNumber: string, tenantId: string, customerId: string, customerName: string, shipFromSiteName: string, salesPerson?: string | null, poNumber: string, program?: string | null, orderKindId?: string | null, orderKindName?: string | null, termsId?: string | null, effectiveRoute?: string | null, status: Types.OrderStatus, orderType: Types.OrderType, paymentStatus: Types.PaymentStatus, source: Types.OrderSource, freightChargeType?: number | null, numberOfLines: number, initializedDate?: Types.TDateISO | null, submittedAt?: Types.TDateISO | null, expectedDeliveryDate?: Types.TDateISO | null, weekNumber?: number | null, syncDate?: Types.TDateISO | null, shippedDate?: Types.TDateISO | null, erpId?: string | null, finalCredit?: boolean | null, produceAllocate?: boolean | null, hasMakeToOrderLine?: boolean | null, allocationStatus?: Types.OrderAllocationStatus | null, lastAllocatedDate?: Types.TDateISO | null, scheduledOrdersCount?: number | null, shipNotes?: string | null, pullNotes?: string | null, generalNotes?: string | null, loadFactor?: number | null, invoiceStatus: Types.OrderInvoiceStatus, creditApplicationStatus?: Types.CreditApplicationStatus | null, quickBooksExportStatus: Types.QuickBooksExportStatus, quickBooksRemoteInvoiceId?: string | null, quickBooksExportError?: string | null, quoteValidUntil?: string | null, followUpOn?: string | null, onHold: boolean, holdReason: string, billingAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, locations: { __typename?: 'OrderLocationDocumentData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } }, amountPaid?: { __typename?: 'MoneyData', amount: number, currency: string } | null, balance?: { __typename?: 'MoneyData', amount: number, currency: string } | null, confirmationEmail?: { __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string } | null, orderTotal: { __typename?: 'MoneyData', amount: number, currency: string }, customerTotal: { __typename?: 'MoneyData', currency: string, amount: number }, freightAmount?: { __typename?: 'MoneyData', amount: number, currency: string } | null, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }> };

export type GetCombinedOrdersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CombinedOrderDocumentFilterInput>;
  combinedOrder?: Types.InputMaybe<Array<Types.CombinedOrderDocumentSortInput> | Types.CombinedOrderDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCombinedOrdersQuery = { __typename?: 'Query', combinedOrders?: { __typename?: 'CombinedOrdersConnection', totalCount: number, nodes?: Array<{ __typename?: 'CombinedOrderDocument', orderEntityType: Types.OrderEntityType, orderEntityId: string, orderEntityNumber: string, tenantId: string, customerId: string, customerName: string, shipFromSiteName: string, salesPerson?: string | null, poNumber: string, program?: string | null, orderKindId?: string | null, orderKindName?: string | null, termsId?: string | null, effectiveRoute?: string | null, status: Types.OrderStatus, orderType: Types.OrderType, paymentStatus: Types.PaymentStatus, source: Types.OrderSource, freightChargeType?: number | null, numberOfLines: number, initializedDate?: Types.TDateISO | null, submittedAt?: Types.TDateISO | null, expectedDeliveryDate?: Types.TDateISO | null, weekNumber?: number | null, syncDate?: Types.TDateISO | null, shippedDate?: Types.TDateISO | null, erpId?: string | null, finalCredit?: boolean | null, produceAllocate?: boolean | null, hasMakeToOrderLine?: boolean | null, allocationStatus?: Types.OrderAllocationStatus | null, lastAllocatedDate?: Types.TDateISO | null, scheduledOrdersCount?: number | null, shipNotes?: string | null, pullNotes?: string | null, generalNotes?: string | null, loadFactor?: number | null, invoiceStatus: Types.OrderInvoiceStatus, creditApplicationStatus?: Types.CreditApplicationStatus | null, quickBooksExportStatus: Types.QuickBooksExportStatus, quickBooksRemoteInvoiceId?: string | null, quickBooksExportError?: string | null, quoteValidUntil?: string | null, followUpOn?: string | null, onHold: boolean, holdReason: string, billingAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, locations: { __typename?: 'OrderLocationDocumentData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } }, amountPaid?: { __typename?: 'MoneyData', amount: number, currency: string } | null, balance?: { __typename?: 'MoneyData', amount: number, currency: string } | null, confirmationEmail?: { __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string } | null, orderTotal: { __typename?: 'MoneyData', amount: number, currency: string }, customerTotal: { __typename?: 'MoneyData', currency: string, amount: number }, freightAmount?: { __typename?: 'MoneyData', amount: number, currency: string } | null, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetRecentCombinedOrdersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CombinedOrderDocumentFilterInput>;
  combinedOrder?: Types.InputMaybe<Array<Types.CombinedOrderDocumentSortInput> | Types.CombinedOrderDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetRecentCombinedOrdersQuery = { __typename?: 'Query', combinedOrders?: { __typename?: 'CombinedOrdersConnection', nodes?: Array<{ __typename?: 'CombinedOrderDocument', orderEntityType: Types.OrderEntityType, orderEntityId: string, orderEntityNumber: string, tenantId: string, customerId: string, customerName: string, shipFromSiteName: string, salesPerson?: string | null, poNumber: string, program?: string | null, orderKindId?: string | null, orderKindName?: string | null, termsId?: string | null, effectiveRoute?: string | null, status: Types.OrderStatus, orderType: Types.OrderType, paymentStatus: Types.PaymentStatus, source: Types.OrderSource, freightChargeType?: number | null, numberOfLines: number, initializedDate?: Types.TDateISO | null, submittedAt?: Types.TDateISO | null, expectedDeliveryDate?: Types.TDateISO | null, weekNumber?: number | null, syncDate?: Types.TDateISO | null, shippedDate?: Types.TDateISO | null, erpId?: string | null, finalCredit?: boolean | null, produceAllocate?: boolean | null, hasMakeToOrderLine?: boolean | null, allocationStatus?: Types.OrderAllocationStatus | null, lastAllocatedDate?: Types.TDateISO | null, scheduledOrdersCount?: number | null, shipNotes?: string | null, pullNotes?: string | null, generalNotes?: string | null, loadFactor?: number | null, invoiceStatus: Types.OrderInvoiceStatus, creditApplicationStatus?: Types.CreditApplicationStatus | null, quickBooksExportStatus: Types.QuickBooksExportStatus, quickBooksRemoteInvoiceId?: string | null, quickBooksExportError?: string | null, quoteValidUntil?: string | null, followUpOn?: string | null, onHold: boolean, holdReason: string, billingAddress: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, locations: { __typename?: 'OrderLocationDocumentData', id: string, code: string, storeNumber: string, name: string, description: string, region: string, market: string, adGroup: string, globalLocationNumber: string, priceGroupId?: string | null, priceGroupName?: string | null, termsId?: string | null, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } }, amountPaid?: { __typename?: 'MoneyData', amount: number, currency: string } | null, balance?: { __typename?: 'MoneyData', amount: number, currency: string } | null, confirmationEmail?: { __typename?: 'ConfirmationEmailData', sent: Types.TDateISO, toEmail: string } | null, orderTotal: { __typename?: 'MoneyData', amount: number, currency: string }, customerTotal: { __typename?: 'MoneyData', currency: string, amount: number }, freightAmount?: { __typename?: 'MoneyData', amount: number, currency: string } | null, invoices: Array<{ __typename?: 'OrderInvoiceLink', invoiceId: string, invoiceNumber: string, standing: Types.InvoiceStanding, openBalance: number }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetPaymentStatusesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CombinedOrderDocumentFilterInput>;
}>;


export type GetPaymentStatusesQuery = { __typename?: 'Query', paymentStatuses: Array<Types.PaymentStatus> };

export const CombinedOrderGridItemFragmentDoc = new TypedDocumentString(`
    fragment CombinedOrderGridItem on CombinedOrderDocument {
  orderEntityType
  orderEntityId
  orderEntityNumber
  tenantId
  customerId
  customerName
  shipFromSiteName
  salesPerson
  poNumber
  program
  orderKindId
  orderKindName
  termsId
  effectiveRoute
  billingAddress {
    ...AddressData
  }
  locations {
    id
    code
    storeNumber
    name
    address {
      ...Address
    }
    description
    region
    market
    adGroup
    globalLocationNumber
    priceGroupId
    priceGroupName
    termsId
  }
  status
  orderType
  paymentStatus
  source
  amountPaid {
    amount
    currency
  }
  balance {
    amount
    currency
  }
  confirmationEmail {
    sent
    toEmail
  }
  orderTotal {
    amount
    currency
  }
  customerTotal {
    ...MoneyAmount
  }
  freightAmount {
    amount
    currency
  }
  freightChargeType
  numberOfLines
  initializedDate
  submittedAt
  expectedDeliveryDate
  weekNumber
  syncDate
  shippedDate
  erpId
  finalCredit
  produceAllocate
  hasMakeToOrderLine
  allocationStatus
  lastAllocatedDate
  scheduledOrdersCount
  shipNotes
  pullNotes
  generalNotes
  loadFactor
  invoiceStatus
  creditApplicationStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  quickBooksExportStatus
  quickBooksRemoteInvoiceId
  quickBooksExportError
  quoteValidUntil
  followUpOn
  onHold
  holdReason
}
    fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment MoneyAmount on MoneyData {
  currency
  amount
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}`, {"fragmentName":"CombinedOrderGridItem"});
export const GetCombinedOrdersDocument = new TypedDocumentString(`
    query GetCombinedOrders($where: CombinedOrderDocumentFilterInput, $combinedOrder: [CombinedOrderDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  combinedOrders(
    where: $where
    order: $combinedOrder
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...CombinedOrderGridItem
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment CombinedOrderGridItem on CombinedOrderDocument {
  orderEntityType
  orderEntityId
  orderEntityNumber
  tenantId
  customerId
  customerName
  shipFromSiteName
  salesPerson
  poNumber
  program
  orderKindId
  orderKindName
  termsId
  effectiveRoute
  billingAddress {
    ...AddressData
  }
  locations {
    id
    code
    storeNumber
    name
    address {
      ...Address
    }
    description
    region
    market
    adGroup
    globalLocationNumber
    priceGroupId
    priceGroupName
    termsId
  }
  status
  orderType
  paymentStatus
  source
  amountPaid {
    amount
    currency
  }
  balance {
    amount
    currency
  }
  confirmationEmail {
    sent
    toEmail
  }
  orderTotal {
    amount
    currency
  }
  customerTotal {
    ...MoneyAmount
  }
  freightAmount {
    amount
    currency
  }
  freightChargeType
  numberOfLines
  initializedDate
  submittedAt
  expectedDeliveryDate
  weekNumber
  syncDate
  shippedDate
  erpId
  finalCredit
  produceAllocate
  hasMakeToOrderLine
  allocationStatus
  lastAllocatedDate
  scheduledOrdersCount
  shipNotes
  pullNotes
  generalNotes
  loadFactor
  invoiceStatus
  creditApplicationStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  quickBooksExportStatus
  quickBooksRemoteInvoiceId
  quickBooksExportError
  quoteValidUntil
  followUpOn
  onHold
  holdReason
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment MoneyAmount on MoneyData {
  currency
  amount
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetRecentCombinedOrdersDocument = new TypedDocumentString(`
    query GetRecentCombinedOrders($where: CombinedOrderDocumentFilterInput, $combinedOrder: [CombinedOrderDocumentSortInput!], $first: Int) {
  combinedOrders(where: $where, order: $combinedOrder, first: $first) {
    nodes {
      ...CombinedOrderGridItem
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment CombinedOrderGridItem on CombinedOrderDocument {
  orderEntityType
  orderEntityId
  orderEntityNumber
  tenantId
  customerId
  customerName
  shipFromSiteName
  salesPerson
  poNumber
  program
  orderKindId
  orderKindName
  termsId
  effectiveRoute
  billingAddress {
    ...AddressData
  }
  locations {
    id
    code
    storeNumber
    name
    address {
      ...Address
    }
    description
    region
    market
    adGroup
    globalLocationNumber
    priceGroupId
    priceGroupName
    termsId
  }
  status
  orderType
  paymentStatus
  source
  amountPaid {
    amount
    currency
  }
  balance {
    amount
    currency
  }
  confirmationEmail {
    sent
    toEmail
  }
  orderTotal {
    amount
    currency
  }
  customerTotal {
    ...MoneyAmount
  }
  freightAmount {
    amount
    currency
  }
  freightChargeType
  numberOfLines
  initializedDate
  submittedAt
  expectedDeliveryDate
  weekNumber
  syncDate
  shippedDate
  erpId
  finalCredit
  produceAllocate
  hasMakeToOrderLine
  allocationStatus
  lastAllocatedDate
  scheduledOrdersCount
  shipNotes
  pullNotes
  generalNotes
  loadFactor
  invoiceStatus
  creditApplicationStatus
  invoices {
    ...OrderInvoiceLinkFields
  }
  quickBooksExportStatus
  quickBooksRemoteInvoiceId
  quickBooksExportError
  quoteValidUntil
  followUpOn
  onHold
  holdReason
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment MoneyAmount on MoneyData {
  currency
  amount
}
fragment OrderInvoiceLinkFields on OrderInvoiceLink {
  invoiceId
  invoiceNumber
  standing
  openBalance
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetPaymentStatusesDocument = new TypedDocumentString(`
    query GetPaymentStatuses($where: CombinedOrderDocumentFilterInput) {
  paymentStatuses(where: $where)
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCombinedOrders: build.query<GetCombinedOrdersQuery, GetCombinedOrdersQueryVariables | void>({
      query: (variables) => ({ document: GetCombinedOrdersDocument, variables })
    }),
    GetRecentCombinedOrders: build.query<GetRecentCombinedOrdersQuery, GetRecentCombinedOrdersQueryVariables | void>({
      query: (variables) => ({ document: GetRecentCombinedOrdersDocument, variables })
    }),
    GetPaymentStatuses: build.query<GetPaymentStatusesQuery, GetPaymentStatusesQueryVariables | void>({
      query: (variables) => ({ document: GetPaymentStatusesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCombinedOrdersQuery, useLazyGetCombinedOrdersQuery, useGetRecentCombinedOrdersQuery, useLazyGetRecentCombinedOrdersQuery, useGetPaymentStatusesQuery, useLazyGetPaymentStatusesQuery } = injectedRtkApi;
